<template>
	<div>
		<AiAssistantFactory v-bind="aiAssistantProps" v-on="$listeners" />
	</div>
</template>

<script>
import AiAssistantFactory from '@/components/CodeBlockAiTabs/AiAssistantFactory.vue';

export default {
	name: 'AiAssistantTab',
	components: { AiAssistantFactory },
	props: { aiAssistantProps: { type: Object } },
};
</script>

<style scoped lang="scss"></style>
